import crypto from 'crypto';

export const md5 = function(string) {
  return crypto.createHash('md5').update(string).digest('hex');
}